export default {
  logs: {
    export: {
      btn: 'Export',
      text: 'operation log'
    },
    overtimeError: 'Logs older than one year are not available for viewing. Please select a different time period.',
    operateSystem: {
      value3: 'Scanat App',
      value4: 'Scanat Web',
      value1: 'ID Management'
    },
    operatePage: {
      login: 'Login/Registration',
      personal_setting: 'Personal Settings',
      local_model: 'Local Models',
      in_box: 'Inbox',
      cloud_model: 'Cloud Models',
      sample_model: 'Sample List',
      main_list: 'Main List',
      member_manage: 'ID Management',
      company_info: 'Company Information',
      order_manage: 'Order History',
      SharedSpace: 'Shared Space',
      TeamsSpace: 'Team Space',
      team_space: 'Team Space',
      personal_space: 'Personal Space',
      model_link: 'Model link',
      invite_link: 'Invitation link'
    },
    operateType: {
      login: 'Login',
      register: 'Register',
      cancellation: 'Delete Account',
      deleteModel: 'Delete Model',
      addModel: 'Create New Model',
      viewModel: 'View Model',
      viewSampleModel: 'View Model',
      editModel: 'Edit Model',
      editModelInfo: 'Edit Model',
      editModelAvatar: 'Edit Model',
      editModelName: 'Edit Model',
      shareModel: 'Send Model',
      copyModelShareLink: 'Send Model',
      moveModel: 'Move Model',
      uploadModel: 'Upload Model',
      exportModel: 'Export Model',
      copyModel: 'Copy Model',
      applyCad: 'Request CAD Drawing',
      addFolder: 'Create New Folder',
      editFolder: 'Edit Folder',
      deleteFolder: 'Delete Folder',
      moveFolder: 'Move Folder',
      downloadModel: 'Download Model',
      buyAccountPlan: 'Purchase Plan',
      inviteMember: 'Add New Member',
      addEnableMember: 'Add New Member',
      addDisableMember: 'Add New Member',
      enableMember: 'Edit Member',
      disableMember: 'Edit Member',
      setMemberAdmin: 'Edit Member',
      unsetMemberAdmin: 'Edit Member',
      editMemberName: 'Edit Member',
      editCustomerInfo: 'Edit Information',
      downloadInvoices: 'Download transaction documents',
      addId: 'Add Member ID',
      switchCard: 'Change Payment Credit Card',
      batchAdd: 'Add in Bulk',
      batchDelete: 'Delete in Bulk',
      activeMember: 'Activate Member ID',
      deleteMember: 'Delete Member ID',
      payOrder: 'Order Payment',
      cancelOrder: 'Order Cancellation',
      PermissionChange: 'Permission Change',
      URLreset: 'URL Reset',
      FolderSharing: 'Folder Sharing',
      expandOrder: 'Expansion of ID count',
      changeCard: 'Change Payment Credit Card',
      batchAddMembers: 'Add in Bulk',
      batchDeleteMembers: 'Delete in Bulk',
      exportMember: 'Export',
      buyOrder: 'Purchase Plan',
      addMember: 'Add New Member',
      editCustomer: 'Edit Information',
      planCancelApplication: 'Cancel subscription',
      editLink: 'Edit Link',
      moveModelHome: 'Move Model',
      moveFolderHome: 'Move Folder',
      copyLink: 'Send Model',
      changeLink: 'Edit Link',
      changeLinkPassword: 'Edit Link',
      resetPassword: 'Password Reset',
      addMemberNew: 'Add New Member',
      editMemberStatus: 'Edit Member',
      editMemberNew: 'Edit Member',
      enable: 'Enable Member',
      disable: 'Disable Member',
      changeSeat: 'Changed ID consumption setting',
      changeRole: 'Edit Role ',
      uploadFile: 'Import Model File',
      manageCollaborator: 'Manage collaborators',
      moveFolderToFolder: 'Move Folder',
      moveFolderToRoot: 'Move Folder',
      moveModelToFolder: 'Move Model',
      moveModelToRoot: 'Move Model',
      addCollaborator: 'Manage collaborators',
      deleteCollaborator: 'Manage collaborators',
      updateCollaborator: 'Manage collaborators',
      inviteCollaborator: 'Add collaborators',
      resentInvite: 'Add collaborators',
      resentInviteWithDate: 'Add collaborators',
      acceptInvite: 'Accept invitation',
      viewFolder: 'Open the folder',
      uploadToFolder: 'Upload Model',
      uploadToRoot: 'Upload Model',
      importFileToRoot: 'Import Model File',
      importFileToFolder: 'Import Model File'
    },
    detail: {
      register: 'Created account',
      login: 'Logged into the system',
      cancellation: 'Deleted account',
      deleteModel: 'Deleted model "{detail0}"',
      addModel: 'Scanned model "{detail0}" with "{detail1}"',
      viewModel: 'Viewed model "{detail0}"',
      editModelInfo: 'Updated model "{detail0}" information to "Model name: {detail1}；Postal Code: {detail2}；Address: {detail3}；Building name: {detail4}"',
      editModelAvatar: 'Changed cover image for model "{detail0}"',
      editModel: 'Performed "{detail1}" operation on model "{detail0}"',
      moveModel: 'Moved model "{detail0}" to folder "{detail1}"',
      uploadModel: 'Uploaded model "{detail0}" to cloud',
      exportModel: 'Exported data for model "{detail0}"',
      copyModel: 'Copied model "{detail0}" as "{detail1}"',
      applyCad: 'Requested CAD drawing for model "{detail0}"',
      addFolder: 'Created new folder "{detail0}"',
      editFolder: 'Renamed folder "{detail0}" to "{detail1}"',
      deleteFolder: 'Deleted folder "{detail0}"',
      moveFolder: 'Moved folder "{detail0}" to folder "{detail1}"',
      downloadModel: 'Downloaded model "{detail0}"',
      viewSampleModel: 'Viewed "sample model"',
      editModelName: 'Renamed model "{detail0}" to "{detail1}"',
      buyAccountPlan: 'Purchased "{detail0}". ID Limit: {detail1} user(s), Total price (incl. tax): {detail2}JPY, Payment method: "{detail3}"',
      addEnableMember: 'Added member "{detail0}", status: "Active"',
      addDisableMember: 'Added member "{detail0}", status: "Disabled"',
      inviteMember: 'Added member "{detail0}", currently awaiting invitation approval',
      enableMember: 'Set member "{detail0}" status to "Active"',
      disableMember: 'Set member "{detail0}" status to "Disabled"',
      setMemberAdmin: 'Granted administrator rights for member "{detail0}"',
      unsetMemberAdmin: 'Removed administrator rights for member "{detail0}"',
      editMemberName: 'Renamed member "{detail0}" to "{detail1}"',
      editCustomerInfo: 'Edited company information to "Postal Code: {detail0}, Prefecture: {detail1}, City: {detail2}, Address: {detail3}, Responsible Person: {detail4} {detail5}, Phone Number: {detail6}, Industry: {detail7}, Number of Employees: {detail8}, Primary Business: {detail9}"',
      downloadInvoices: 'Downloaded invoice for order "{detail0}" to local storage',
      moveModelHome: 'Moved model "{detail0}" to "Home"',
      moveFolderHome: 'Moved folder "{detail0}" to "Home"',
      expandOrder: '[Expansion of ID count] Order has been submitted. Order details: "Order Number: {detail0}; Plan: {detail1}; Order Type: ID Addition; Subscription: {detail2}; Additional IDs: {detail3}; Start Date: {detail4}; Amount: {detail5}; Tax: {detail6}; Total Payment Amount: {detail7}"',
      buyOrder: '[Purchase Plan] Order has been submitted. Order details: "Order Number: {detail0}; Plan: {detail1}; Order Type: Purchase; Subscription: {detail2}; IDs:{detail3};Amount: {detail4}; Tax: {detail5}; Total Payment Amount: {detail6}"',
      changeCard: 'Changed the payment credit card to {detail0}.',
      addMember: 'Added member {detail0}. Status: {detail1}.',
      batchAddMembers: 'Bulk added {detail0} members.',
      batchDeleteMembers: 'Bulk deleted {detail0} members.',
      exportMember: 'Exported the member list.',
      activeMember: 'Activated member [{detail0}].',
      deleteMember: 'Deleted member [{detail0}].',
      editCustomer: 'Edited company information to "Company Name: {detail0}; Contact Person: {detail1} {detail2} {detail3}; Postal Code: {detail4}; Address: {detail5}; Industry: {detail6}; Number of Employees: {detail7}; Capital: {detail8}; Main Business: {detail9}"',
      payOrder: 'Payment for order [{detail0}] has been completed. Payment method: {detail1}.',
      cancelOrder: 'Order [{detail0}] has been cancelled.',
      SendModelViewable: 'Send the model "{detail0}" with user "{detail1}". Access permission is "Viewable".',
      CopiedModelPrivateLink: 'Copied the "Private Link" of the model "{detail0}".',
      AddedModelMember: 'Added member "{detail1}" to the model "{detail0}" with "Viewable" permissions.',
      UpdatedModelMember: 'Updated member "{detail1}" in the model "{detail0}" to have "Editable" permissions.',
      RemovedModelViewable: 'Removed "Viewable" permissions for member "{detail1}" in the model "{detail0}".',
      ResetModelPrivateLink: 'Reset the "Private Link" of the model "{detail0}".',
      SharedFolder: 'Shared the folder "{detail0}" with user "{detail1}". ',
      CopiedFolderPublicLink: 'Copied the "Public Link" for the folder "{detail0}".',
      ResetModelPublicLink: 'Reset the "Public Link" for the model "{detail0}".',
      SendModelEditable: 'Send the model "{detail0}" to user "{detail1}". Access permission is "Editable".',
      RenamedFolder: 'The folder "{detail0}" has been renamed to "{detail1}" with the description: "{detail2}".',
      SharedFolderViewable: 'Shared the folder "{detail0}" with user "{detail1}". Access permission is "Viewable".',
      CopiedFolderPrivateLink: 'Copied the "Private link" for the folder "{detail0}".',
      AddedFolderMember: 'Added member "{detail1}" to the folder "{detail0}" with "Viewable" permissions.',
      UpdatedFolderMember: 'Updated member "{detail1}" in the folder "{detail0}" to have "Editable" permissions.',
      RemovedFolderViewable: 'Removed "Viewable" permissions for member "{detail1}" in the folder "{detail0}".',
      ResetFolderPublicLink: 'Reset the "Public Link" for the folder "{detail0}".',
      addModel1: 'Layout Scan',
      addModel2: 'Normal Scan',
      editModel1: 'Trim',
      editModel2: 'Align',
      editModel3: 'Transform',
      buyAccountPlan2: 'Invoice',
      buyAccountPlan1: 'Credit Card',
      editCustomerSex0: 'Male',
      editCustomerSex1: 'Female',
      editCustomerInfo1: 'Construction',
      editCustomerInfo2: 'Manufacturing',
      editCustomerInfo3: 'Real Estate and Goods Rental and Leasing',
      editCustomerInfo4: 'Information and Communications',
      editCustomerInfo5: 'Electricity, Gas, Heat Supply and Water',
      editCustomerInfo6: 'Transport and Postal Services',
      editCustomerInfo7: 'Information Services',
      editCustomerInfo8: 'Scientific Research, Professional and Technical Services',
      editCustomerInfo9: 'Wholesale and Retail Trade',
      editCustomerInfo10: 'Research Industry',
      editCustomerInfo0: '-',
      editCustomerInfoStaff1: '1~50',
      editCustomerInfoStaff2: '51~100',
      editCustomerInfoStaff3: 'More than 100',
      editCustomerInfoStaff0: '-',
      editCustomer1: 'Construction',
      editCustomer2: 'Manufacturing',
      editCustomer3: 'Real Estate and Goods Rental and Leasing',
      editCustomer4: 'Information and Communications',
      editCustomer5: 'Electricity, Gas, Heat Supply and Water',
      editCustomer6: 'Transport and Postal Services',
      editCustomer7: 'Information Services',
      editCustomer8: 'Scientific Research, Professional and Technical Services',
      editCustomer9: 'Wholesale and Retail Trade',
      editCustomer10: 'Research Industry',
      editCustomer0: '-',
      editCustomerStaff1: '1~50',
      editCustomerStaff2: '51~100',
      editCustomerStaff3: 'More than 100',
      editCustomerStaff0: '-',
      payOrder1: 'Credit card',
      payOrder2: 'Invoice',
      addMember0: 'Not Active',
      addMember1: 'Activated',
      period1: 'Annual Billing',
      period2: 'Monthly Billing',
      planCancelApplication: 'Submitted a subscription cancellation request.',
      shareModel: 'Send model "{detail0}" to user "{detail1}"',
      copyModelShareLink: 'Copied shared link for model "{detail0}"',
      changeLinkPassword: 'Changed the password for the password-protected link of model  "{detail0}".',
      ResetModelLink: 'Reset the "{detail1}" of the model "{detail0}".',
      ResetFolderLink: 'Reset \'{detail1}\' of folder "{detail0}".',
      resetPassword: 'The password has been reset.',
      copyLink1: 'Private Link',
      copyLink2: 'Password-protected Link',
      copyLink3: 'Public Link',
      changeLink1: 'Private Link',
      changeLink2: 'Password-protected Link',
      changeLink3: 'Public Link',
      copyLink: 'Copied the "{detail1}" of the model "{detail0}".',
      changeLink: 'Changed sharing link permissions for model  "{detail0}" to  "{detail1}".',
      editMemberStatus: 'Update member "{detail0}" status to "{detail1}" .',
      addMemberNew: 'New member "{detail0}" has been added. Role: "{detail1}"; ID consumption setting: "{detail2}"; Status:  "In Use".',
      editMemberNew: 'Member "{detail0}" has been updated: Name to "{detail1}", Role to "{detail2}", and ID consumption setting to "{detail3}".',
      enable: 'Member "{detail0}" has been enabled.',
      disable: 'Member "{detail0}" has been disabled.',
      changeSeat: 'Update the ID consumption setting of member "{detail0}" to "{detail1}".',
      changeRole: 'Update the role of member "{detail0}" to "{detail1}".',
      role1: 'Super administrator',
      role3: 'Administrator',
      role0: 'Scanat User',
      role4: 'Viewer',
      changeSeat1: 'ON',
      changeSeat0: 'OFF',
      uploadFile: 'The model "{detail0}" has been imported. The file type is {detail1}.',
      uploadToFolder: 'Uploaded model "{detail0}" to folder "{detail2}" of "{detail1}".',
      uploadToRoot: 'Uploaded model "{detail0}" to {detail1}\'s "Home".',
      moveFolderToFolder: 'Moved folder "{detail0}" to {detail1}\'s folder "{detail2}".',
      moveFolderToRoot: 'Moved folder "{detail0}" to {detail1}\'s "Home".',
      moveModelToFolder: 'Moved model "{detail0}" to {detail1}\'s folder "{detail2}".',
      moveModelToRoot: 'Moved model "{detail0}" to {detail1}\'s "Home".',
      addCollaborator: 'Set "{detail2}" as the collaborator on {detail0} "{detail1}" with the permission of "{detail3}".',
      deleteCollaborator: 'Deleted the collaborator "{detail2}" from {detail0} "{detail1}".',
      updateCollaborator: 'Set permission of collaborator "{detail2}" on {detail0} "{detail1}" to "{detail3}".',
      space0: 'Personal Space',
      space1: 'Team Space',
      fileType0: 'Model',
      fileType1: 'Folder',
      collaboratorPermission0: 'View only',
      collaboratorPermission1: 'Editable',
      collaboratorPermission2: 'Manageable',
      importFile: 'The model \\"{detail0}\\" has been imported. The file type is {detail1}.',
      inviteCollaborator: 'Invitation sent to "{detail0}" with {detail1} permission. Expires in {detail2} days.',
      resentInvite: 'Invitation resent to "{detail0}".',
      resentInviteWithDate: 'Invitation resent to "{detail0}". Expires in {detail1} days.',
      acceptInvite: 'Collaborator invitation accepted.',
      viewFolder: 'Folder "{detail0}" has been opened.',
      importFileToRoot: 'Import model \\"{detail0}\\" to the root of {detail1}. The file type is {detail2}.',
      importFileToFolder: 'Import model \\"{detail0}\\" to folder \\"{detail2}\\" in {detail1}. The file type is {detail3}.'
    }
  },
  common: {
    close: 'Close',
    got: 'Close',
    title: {
      email: 'Email'
    },
    cancel: 'Cancel',
    share: 'Share',
    settings: 'Settings',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    done: 'Done',
    name: 'Name',
    loading: 'Loading',
    back: 'Back',
    deleteConfirm: 'Are you sure you want to delete?',
    delete: 'Delete',
    rename: 'Rename',
    empty: 'No data',
    inputhint: 'Please input',
    pre: 'Previous',
    next: 'Next',
    beginning: 'First page',
    last: 'Last page',
    forwardPage: 'Jump to X page',
    summary: 'Total {n} items',
    ok: 'OK',
    select: 'Select',
    confirm: 'Confirm',
    selectAll: 'Select all',
    all: 'All',
    minimize: 'Minimize',
    submit: 'Submit',
    action: 'Action',
    active: 'Activate',
    edit: 'Edit',
    more: 'More',
    batch: 'Batch operation',
    MultiDelete: 'Batch deletion',
    export: 'Export',
    setDefault: 'Set as default',
    create: 'Add new',
    fillin: 'Go fill in',
    reset: 'Reset',
    other: 'Other',
    input: 'Please enter',
    selectHint: 'Please select',
    uploadFile: 'Upload file',
    uploadForm: 'Upload the spreadsheet',
    steps: 'Steps of operation',
    import: 'Confirm import',
    download: 'Download',
    note: 'Remark',
    normalTip: 'Reminder',
    clear: 'Clear',
    remove: 'Deletion',
    move: 'Move',
    scanatId: 'Scanat ID',
    startTime: 'Start time',
    endTime: 'End time',
    page: {
      go: 'Go to Page {detail0}',
      total: 'Total {detail0} items',
      first: 'First Page',
      previous: 'Previous',
      next: 'Next',
      last: 'Last Page',
      perPage: 'per page'
    }
  },
  mesh: {
    export: 'Export Model Data',
    download: 'Download Data',
    all: 'All Data',
    tip: 'Compress and Export All Data of the Model',
    default: 'Mesh',
    pointCloud: 'Point Cloud',
    processing: 'Processing',
    gltf: 'For Android',
    obj: 'Widely Used',
    stl: 'For 3D Printers'
  },
  week: {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun'
  },
  month: {
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec'
  },
  login: {
    passwordWrong: 'Please verify your password.',
    accountUndefined: 'Username does not exist.',
    verifiWrong: 'The verification code is incorrect',
    verifiExpired: 'The verification code has expired.',
    loginVerifiSent: 'The verification code has been sent to your email.',
    verifiSend: 'Resend Code',
    login: 'Login',
    register: 'Register',
    back: 'Click here to login',
    guideRegister: 'Click here to register',
    newAccount: 'Register',
    email: 'Email',
    password: 'Password',
    forgetPassword: 'Forgot password?',
    emailError: 'Invalid email address format.',
    passwordTip: 'Password must be between 10 and 50 characters long and includes at least one half-width letter and one half-width number.',
    emailNone: 'This email is not registered.',
    accountError: 'The E-mail or password is not correct.',
    resetPasswordSent: 'An email has been sent to reset your password.',
    verifiSent: 'Verification code has been sent to your email.',
    passwordConfirm: 'Set Password',
    send: 'Send',
    sent: 'Verification code has been sent.',
    verify: 'Verification Code',
    inputVerify: 'Please enter the 6-digit verification code sent to your email.',
    resetPassword: 'Reset Password',
    noEmpty: 'Please fill in all required fields.',
    verifyFormat: 'The verification code must be 6 digits long.',
    verifyNumber: 'The verification code must be a 6-digit number.',
    checkPassword: 'Please verify your password',
    resetPasswordSuccess: 'Password reset successfully.',
    existUser: 'This user already exists.',
    loginSuccess: 'Logged in successfully.',
    registerSuccess: 'Registration completed successfully.',
    logout: 'Log out',
    terms: 'I agree to <link>Scanat Terms of Use</link>.',
    termsError: 'Please read the Scanat Terms of Use and check the box to indicate your agreement before submitting your registration.',
    alert: {
      title: 'Reminder',
      info: 'We have sent you an email with a link to complete your password reset.'
    },
    invalid: {
      info: 'This password reset link has expired.',
      tip: 'Please request a new password reset link.'
    },
    noExist: {
      info: 'The link does not exist.',
      tip: 'Please check if the link is correct.'
    },
    go: 'Go',
    forgetPasswordToast: 'Too many requests. Please try again in 1 minute.',
    introduction: 'Digitize Space, Create Future',
    verifyText: 'Verification Code'
  },
  error: {
    connectionOut: 'The connection has timed out. Please check your network connection or try again later.',
    server: 'The server is either overloaded or undergoing maintenance. Please try again later.',
    connectionCheck: 'Please check your network connection.',
    contactManage: 'Access denied. Please contact your administrator.',
    noPlan: 'Service unavailable. No subscription plan purchased.',
    overDate: 'Your company\'s {plan} subscription expired on {date}. Service unavailable.',
    unactive: 'Your company\'s {plan} subscription will activate on {date}. Please access after activation.',
    needLevelUp: 'Your company has not purchased this service yet. ',
    noService: 'Access denied. Your company hasn\'t purchased this service',
    emptyName: 'First name or last name cannot be empty.',
    unsaveEdit: 'Please save the edited content first.',
    overSeat: 'The user limit has been reached. You cannot add more members. Please remove some members or expand the ID count.',
    noSelectMember: 'Please check the members to be removed below.',
    bestPlan: 'The current package is the highest version and cannot be upgraded.',
    noPermission: 'No permission.',
    comInfoAction: 'Complete the company information',
    comInfoModal: 'Your company information is not yet complete. Please fill in the company information.',
    comInfoBuy: 'Please complete the company information first, and then proceed with the purchase.',
    comInfoHome: 'Note: Due to incomplete company information, some features may be affected.',
    usedAccount: 'This account is already associated with another company and cannot be added. Please re-enter the information.',
    wrongEmail: 'Please provide a valid postal code.',
    unsavePage: 'Please save the content on this page before proceeding.',
    repetitiveMail: 'Duplicate email addresses have been found in the table. Please review the entries and upload again.',
    otherMember: 'The email address {email} is already associated with an existing account. Please check and upload again.',
    wrongFormat: 'The email address format for {email} is incorrect. Please correct it and upload again.',
    creditExpired: 'The credit card you are using has expired. Please verify the expiration date or use an alternate card.',
    agreement: 'Please check the box to confirm your agreement to the Purchase Agreements.',
    payFailed: 'Payment failed. Please verify your credit card information.',
    noAccess: 'Unable to access this page.',
    overSeatActivation: 'The user limit has been reached.  New members cannot be activated. Please remove some members or expand the ID count.',
    emailEmpty: 'Row {n}: Email address is required. Please complete and upload again.',
    nameExceed: 'Row {n}: First or last name exceeds maximum length (10 characters). Please correct and try again.',
    importExceed: 'You can import a maximum of 100 members at once. Please remove some members from the file and try uploading again.',
    existCompany: 'This account has already been added to the company.',
    invalidAccount: 'This account is invalid. Please contact your administrator.',
    creditDisable: 'Your credit card could not be used. Please verify the details and enter  again.',
    accountDisable: 'This account has been disabled and cannot be accessed.',
    noSeat: 'The "ID Consumption" setting is turned off for this account, so app access is unavailable. ',
    noRight: 'Your account does not have permission to access this service.',
    code: {
      '403': 'Access Denied',
      '404': 'Page Not Found',
      '500': 'Server is overloaded and under maintenance. Please try again later.',
      '502': 'Server is busy. Please try again later.',
      '504': 'Server is busy. Please try again later.'
    },
    oneDevice: 'For security reasons, simultaneous login from multiple devices is not allowed on Scanat Web. Your account has been automatically logged out. Please log in again.',
    overDue: 'Your session has expired. Please log in again.',
    checkNetWork: 'Please check your network connection.',
    timeOut: 'The connection timed out. Please check your network connection or try again later.',
    noCompanyInfo: 'The company information has not been completed. You can purchase a plan only after completing the company information in the "Company Information" menu bar.',
    comInfoDomain: 'Please complete the company information before adding a domain.',
    accountNoAccess: 'This account has been disabled and cannot be logged into.',
    existName: 'This name already exists. Please input a different name.',
    nameTooLong: 'Please enter the model name of 20 characters or less, then upload again.',
    noModel: 'No model data found.'
  },
  complete: {
    save: 'Save completed.',
    export: 'Export completed.',
    setManagement: 'The administrator setup has been successfully completed.',
    cancelSetManag: 'The administrator removal has been successfully completed.',
    card: 'A credit card has been added.',
    cardUpdate: 'The credit card has been updated.',
    cardDeleted: 'The credit card has been removed.',
    importMember: 'Imported successfully',
    invoiceDown: 'The receipt has been successfully downloaded.',
    diagramDown: 'The drawing has been successfully downloaded.',
    invoiceSent: 'The invoice has been successfully sent.',
    bought: 'Thank you! Your purchase was successful.',
    add: 'Added successfully',
    change: 'Updated successfully',
    delete: 'Deleted successfully',
    replace: 'Updated successfully'
  },
  landing: {
    select: 'Please select the system you need to access:\nPlease Select Service',
    idManage: 'ID Management',
    scanatWeb: 'Scanat Web',
    pwChange: 'Change Password',
    logout: 'Log Out',
    tipId: '· Manage Your Account\n  (Update status, change administrative permissions, and more.)\n· Purchase Plan\n· Download invoices and receipts',
    tipScanat: '· Company and individual cloud data management (including features like creating personal folders)\n· Operate models and edit measurement data via PC browser\n· Real-time collaboration on models and measurement data with Internal users',
    alertNoPlan: 'Scanat Web is an optional feature available for Enterprise Plans (Plan B and above). You can view and operate models scanned in web browsers, as well as create model links for sharing with non-Scanat users. For further details, please reach out through our <link>contact form</link> or contact your sales representative.',
    invalidAccount: 'Scanat Web is unavailable now since your account has expired.',
    unnamed: 'Unnamed'
  },
  file: {
    allFile: 'All Files',
    sample: 'Sample Model',
    modelAmount: 'Models',
    newFolder: 'New Folder',
    fileName: 'File Name',
    owner: 'Owner',
    time: 'Uploaded',
    createTime: 'Created',
    scanner: 'Author',
    scanTime: 'Date taken',
    editor: 'Last modified by',
    updateTime: 'Last modified',
    folder: 'Folder',
    fileAmount: '{n} Files',
    createString: 'Created at {time}',
    uploadString: 'Uploaded at {time}',
    updateString: 'Updated at {time}',
    editorString: 'Last modified by {ID} at {time}',
    filter: 'Filter',
    sort: 'Sort',
    restore: 'Restore to Default',
    all: 'All',
    filterStatus: 'Model Status',
    filterCad: 'CAD Requested',
    filterMark: 'Pin Status',
    filterMarked: 'Pinned',
    fiterOwner: 'Owner',
    filterSelfOwner: 'Me',
    filterShared: 'Shared with me',
    updateNewest: 'Updated (Newest first)',
    createNewest: 'Uploaded/Created (Newest first)',
    searchHint: 'Input keyword',
    pagePre: 'Previous',
    pageNext: 'Next',
    pageFirst: 'First',
    pageLast: 'Last',
    operate: 'Operate',
    share: 'Share',
    selectAll: 'Select all',
    rename: 'Rename',
    moveTo: 'Move to',
    tipSample: 'No model data has been uploaded. Please upload models using the mobile application or start by opening the sample model to try out the features.',
    btnSample: 'Explore with Sample Model',
    noFile: 'No files in the current folder.',
    noResult: 'No results found. Please try changing the keyword, checking the input, or adjusting the filters.',
    noSearchResult: ' Please try different keywords, check for typos, or adjust filters.',
    editFolder: 'Edit the folder',
    folderName: 'Folder Name',
    folderNameHint: 'Please input the folder name.',
    folderDesc: 'Remarks',
    folderDescHint: 'If there are any remarks, please enter them.',
    folderDescLimit: '同上',
    editModel: 'Model Rename',
    modelName: 'Model Name',
    modelNameHint: 'Please input the model name.',
    dataSize: 'Data Size',
    shareString: 'Shared by {ID} at {time}',
    id: {
      log: 'User operation log',
      logCompany: '{company} Operation Log',
      Invoice: 'Invoice{订单号}',
      MemberList: '{会社名}Member List{YYYYMMDD}',
      PlanOrderList: 'Plan Order List{YYYYMMDD}',
      CADOrderList: 'CAD Order List{YYYYMMDD}',
      CustomerInformationList: 'Customer Information List{YYYYMMDD}',
      AccountList: 'Account List{YYYYMMDD}',
      UserBatchImportTemplate: 'User Batch Import Template',
      transactionFiles: 'Transaction Documents{number}',
      memberList: 'Member List{YYYYMMDD}',
      planOrderList: 'Plan Order List{YYYYMMDD}',
      cadOrderList: 'CAD Order List{YYYYMMDD}',
      customerInformationList: 'Customer Information List{YYYYMMDD}',
      companyMemberList: '{company}Member List{YYYYMMDD}',
      accountList: 'Account List{YYYYMMDD}',
      userBatchImportTemplate: 'User Batch Import Template',
      invoice: 'Invoice {number}'
    },
    noResultTitle: 'No results found.',
    code: {
      get: 'Get Embed Code',
      mode: 'Loading Method',
      manual: 'Manual Load',
      auto: 'Auto Load',
      copy: 'Copy Embed Code',
      language: 'Display Language',
      copySuccess: 'Code copied'
    },
    delete: {
      title: 'Are you sure you want to delete this model?',
      prompt: 'After deletion, members who have permission for the models will no longer be able to access them.',
      noAuth: 'Some files cannot be deleted due to insufficient permissions. Please reselect.'
    },
    deleteFolder: {
      title: 'Are you sure you want to delete this folder?',
      prompt: 'After deletion, you and other members will no longer be able to access the models within the selected folder.'
    },
    mark: {
      cancledToast: 'Not pinned',
      markedToast: 'Pinned'
    },
    copy: 'copy',
    import: {
      button: 'Import model',
      title: 'Import model',
      tip1: 'Select a 3D file or drop it here to import.',
      tip2: 'Supported formats',
      tip3: 'Max size: 500MB. If textures are included, please compress them into a ZIP file before importing.',
      select: 'Select the file',
      reSelect: 'Reselect the file',
      release: 'Drop file to import',
      refresh: 'Import in progress.Do not reload or close the page. Interrupting the process will cause the import to fail.',
      fail: 'Unable to import. Please try again.',
      prompt: 'Import is in progress. Reloading the page will prevent the import from completing. Are you sure?',
      error: {
        checkNet: 'Import failed. Please check your network and try again.',
        parsingFailed: 'Could not parse the model. Please check the file and try again.',
        system: 'An error occurred during processing. Please wait a moment and try again.',
        invalidFile: 'No valid model data found in the ZIP file. Please check the file and try again.'
      }
    },
    itemsPerPage: 'Items per page',
    teamSpace: 'Team Space',
    mySpace: 'Personal Space',
    folderEmptyDesc: 'No remarks.',
    sortBy: {
      updateTimeDescending: 'Last modified (Newest first)',
      updateTimeAscending: 'Last modified (Oldest first)',
      createTimeDescending: 'Uploaded/Created (Newest first)',
      createTimeAscending: 'Uploaded/Created (Oldest first)',
      firstletterDescending: 'A to Z',
      sizeDesc: 'Size (Descending)',
      sizeAsc: 'Size (Ascending)'
    },
    creator: 'Creator',
    createOrUploadTime: 'Upload date',
    noFound: {
      text: 'No folder named "{0}" was found. Please try a different keyword.'
    },
    move: {
      noAuth: 'Some files cannot be moved due to insufficient permissions. Please reselect.'
    },
    modelNum: '{n} model(s)'
  },
  filemodal: {
    deletAll: 'Are you sure you want to delete?',
    selectMove: 'Move To',
    move: 'Move Here',
    noData: 'No data',
    share: 'Share Model Link',
    copyLink: 'Copy',
    copySuccess: 'Link copied successfully',
    shareTip: '1. Users with Scanat Web permissions: Can view and edit the model; changes will be synced to the source shared model in real time.\\n\n2. Users without Scanat Web permissions: Can view and edit the model, but any changes will not be applied or saved to the source shared model.',
    moveSuccess: 'Moved successfully',
    folderSuccess: 'Folder created successfully',
    changeSuccess: 'Modified successfully',
    noSpecialSymbol: 'Special characters are not allowed.',
    sharePromptOld: '1.Users with ScanatWeb permissions: Can view and edit the model simultaneously.\n2.Users without ScanatWeb permissions: Can view the model, but simultaneous editing is not supported.',
    moveFolderTitle: 'Move the folder.',
    moveModelTitle: 'Move the model',
    moveFileTitle: 'Move the file.',
    moveFileDesc: 'The moved file will follow the permission settings of the destination folder. Additionally, current collaborators may lose access to the file.',
    moveFolderDesc: 'The moved folder will follow the permission settings of the destination folder. Additionally, current collaborators may lose access to the folder.',
    moveModelDesc: 'The moved model will follow the permission settings of the destination folder. Additionally, current collaborators may lose access to the model.',
    deleteComfirm: 'Cannot be restored after deletion. Do you want to delete it?',
    cannotEdit: 'Unable to edit because the file has been deleted.',
    cannotAccess: 'Unable to access.The file has been deleted.'
  },
  language: {
    ja: '日本語',
    en: 'English',
    cn: '简体中文'
  },
  profile: {
    basic: 'Basic information',
    account: 'Account',
    name: 'Name',
    company: 'Affiliated company',
    superManage: 'Super administrator',
    manage: 'Administrator',
    member: 'Standard member',
    deregisterAccount: 'Account deletion',
    deregisterTip: '1.Please note that your personal information and history cannot be restored.\\n\n2.All model records and transaction history will be permanently deleted and cannot be recovered.\\n\n3.If you are the super administrator and there are still active accounts within the team that have not been deleted, you will not be able to log out.',
    deregisterWarningCo: 'Deleting the account will permanently remove all model records associated with the company, and these cannot be restored.',
    deregisterWarningUser: 'Deleting the account will permanently remove all of your model records, and these cannot be restored.',
    deregisterConfirm: 'Confirmation of Account Deletion',
    deregisterfail1: 'In your team, there are still',
    deregisterfail2: 'active accounts ',
    deregisterfail3: 'in use. Please visit the team management page to remove the members, and then proceed with the account cancellation.',
    deregisterComplete: 'The account deletion has been successfully completed.',
    continue: 'Proceed with account deletion',
    manageAccount: 'Manage Account'
  },
  company: {
    setting: 'Company infomation',
    basic: 'Basic Infomation',
    expand: 'Additional Infomation',
    name: 'Company Name',
    owner: 'Person in Charge',
    ownerLastname: 'Last Name',
    ownerName: 'First Name',
    zipcode: 'Postal Code',
    addressProvince: 'State/Province',
    addressCity: 'City/Ward/Town/Village',
    addressDistrict: 'District/Block/House no.',
    industry: 'Type of Industry',
    industryArchi: 'Construction',
    industryManu: 'Manufacturing',
    industryEstate: 'Real Estate and Goods Rental and Leasing',
    industryTel: 'Information and Communications',
    industryElectric: 'Electricity, Gas, Heat Supply and Water',
    industryTrans: 'Transport and Postal Services',
    industryInfo: 'Information Services',
    industryStudy: 'Scientific Research, Professional and Technical Services',
    industryRetail: 'Wholesale and Retail Trade',
    industryResearch: 'Research Industry',
    scale: 'Number of Employees',
    scaleSmall: 'Below 50',
    scaleMedium: '50-100',
    scaleLarge: 'More than 100',
    service: 'Main Business',
    inputCorrectPhone: 'Please enter a valid phone number.',
    inputNumber: 'Please enter a numeric value.',
    domainManage: 'Domain Management',
    domainList: 'Domain List',
    domainDesc: '*Scanat Web allows you to embed model detail pages on external sites. You can add third-party domain names here, and the embedding code will only work on the domains you\'ve registered. You can add a maximum of 10 domains.',
    domain: 'Domain',
    addDomain: 'Add Domain',
    editDomain: 'Edit Domain',
    deleteDomain: 'Delete Domain',
    inputDomain: 'Please enter a domain name',
    domainError: 'Please enter a valid domain name',
    deleteDomainTip: 'Are you sure you want to delete this domain? Once deleted, the model embedding code will no longer work on this domain.',
    nameInput: 'Please enter company name',
    ownerSexual: 'Gender',
    ownerMale: 'Male',
    ownerFemale: 'Female',
    numberInput: 'Please enter phone number',
    zipcodeInput: 'Please enter postal code',
    address: 'Address',
    addressDetails: 'Building/Room',
    industrySelect: 'Please select type of industry',
    scaleSelect: 'Please select number of employees',
    capital: 'Capital',
    capitalInput: 'Please enter capital',
    capitalUnit: 'JPY',
    serviceInput: 'Please enter main business',
    domainIframeError: 'The content cannot be displayed because this domain is not authorized.',
    ownerNameTitle: 'Name',
    ownerGenderTitle: 'Gender',
    ownerPhoneTitle: 'Phone',
    DomainExsit: 'The domain you entered is already in use. Please enter a different domain name.'
  },
  card: {
    manage: 'Manage credit card',
    number: 'Card number',
    dueDate: 'Expiration date',
    status: 'Status',
    owner: 'Cardholder name',
    statusNormal: 'Active',
    statusExpired: 'Expired',
    default: 'Default credit card',
    setDefault: 'Set as default',
    create: 'Add new card',
    inputNumber: 'Please enter your credit card number.',
    validity: 'Expiration date',
    inputMonth: 'Please enter the month',
    inputYear: 'Please enter the 2-digit year',
    securityCode: 'Security code',
    inputSecurityCode: 'Please enter  security code',
    inputOwner: 'Please enter the name of the cardholder.',
    errorNumber: 'Please enter the 16-digit card number.',
    errorMonth: 'Please select and enter a month from January to December',
    errorYear: 'Please enter valid expiration year.',
    errorSecurity: 'Please enter the 3-digit security code.',
    errorOwner: 'Please enter the name of the cardholder.',
    errorExpired: 'This credit card has expired. Please verify the expiration date or use an alternate card.',
    delete: 'Remove credit card information',
    deleteConfirm: 'Are you sure you wish to remove the credit card ending in {number}?',
    deleteComplete: 'The credit card information has been successfully removed.',
    defaultComplete: 'Set as default successfully.',
    emptyTitle: 'No credit card information added currently.',
    emptyDesc: 'Please click the button below to add your credit card information.',
    bind: 'Current payment',
    inputMonthYear: 'MM/YY',
    error: {
      InvalidNumber: 'Your card number is invalid.',
      tooShortNumber: 'Your card number is incomplete.',
      invalidDate: 'Your card’s expiration year is invalid.',
      incompleteDate: 'Your card’s expiration date is incomplete.',
      expiredDate: 'Your card’s expiration year is in the past.',
      invalidSecurityCode: 'Your card’s security code is incomplete.'
    }
  },
  home: {
    title: 'Home',
    modelAmount: 'Number of models',
    memberAmount: 'Number of members ',
    orderAmount: 'Number of orders',
    quick: 'Shortcut link',
    completeInfo: 'Complete the company information',
    team: 'Create  team',
    cowork: 'Model collaboration',
    order: 'View order details',
    read: 'Recommended reading for beginners',
    back: 'Return to the homepage'
  },
  plan: {
    a: 'Plan A - Starter',
    b: 'Plan B - Basic',
    c: 'Plan C - Business',
    d: 'Plan D - Enterprise',
    selectPlan: 'Select a subscription plan',
    id: 'Number of User IDs',
    app: 'App version',
    appWeb: 'App version + Web version',
    price: 'Starting from {price} JPY',
    none: 'There are no available plans currently.',
    now: 'Current plan',
    statusActive: 'Subscribed',
    statusUnactive: 'Awaiting activation',
    end: 'Expired',
    planDetail: 'More details',
    idMoreThan: 'or more',
    bApp: 'Plan B - Basic (App only)',
    bAll: 'Plan B - Basic (Web + App)',
    aYearText: 'Save 24,000 yen annually vs. monthly payments',
    unSelected: 'No plan selected.'
  },
  order: {
    list: 'Order History',
    plan: 'Plan Order',
    cad: 'CAD Order',
    statusUnpay: 'Unpaid',
    trial: 'Available for early trial',
    statusPaid: 'Paid',
    statusCancel: 'Cancelled',
    statusComplete: 'Process completed',
    statusProcessing: 'In progress',
    searchHint: 'Enter order number/plan name to search',
    number: 'Order number',
    name: 'Plan name',
    payMethod: 'Subscription',
    payMonth: 'Monthly Billing',
    payYear: 'Annual Billing',
    switchPayMethod: 'Switch subscription method',
    switchPay: 'Switch subscription method',
    switchMonthTip: 'Are you sure you want to change the subscription for Plan A to monthly billing?',
    switchYearTip: 'Are you sure you want to change the subscription for Plan A to annual billing?',
    currentPeriod: 'Current plan expiration date',
    nextPeriod: 'Next plan expiration date',
    periord: 'Expiration date',
    selectSeat: 'Select the number of IDs',
    seat: 'Number of IDs',
    seatAdded: 'New available IDs',
    seatAddSum: 'Number of new available IDs',
    seatAddTime: 'Date of ID expansion',
    selectTime: 'Please select a date',
    seatPeople: '{n}',
    seatUnactive: '{n} IDs are pending activation',
    seatTip: 'The number of IDs selected here will be the total number of IDs available for the entire team to use the service. For example, if you select 10, the total number of IDs available for the team will be 10.',
    packageCount: 'Package Count',
    packageCountTip: 'Select the number of packages to purchase',
    additionalIdCount: 'Additional ID Count',
    additionalIdCountTip: 'Additional IDs purchased beyond the base package ID count',
    totalIdCount: 'Total {count} IDs',
    packageBaseIdCount: 'Selected package includes {count} IDs',
    seatOver: 'The member count has exceeded the limit',
    seatOverTip: 'Your current team has {n} members. Please purchase a plan with {n} or more IDs, or remove some members from the management page before making the purchase again.',
    memberUsed: 'Number of IDs in use',
    deleteMemble: 'Remove team member',
    cancelTip: 'Canceled on {date}',
    expandSeat: 'Expansion of ID count',
    purchase: 'Purchase a plan',
    purchaseNow: 'Purchase now',
    levelUp: 'Upgrade',
    renewal: 'Renewal',
    buy: 'Purchase',
    changeTime: 'Change the service usage period',
    olderTime: 'Current usage period',
    newTime: 'Updated usage period',
    startTime: 'Service start date',
    endTime: 'Service end date',
    updateTime: 'Upgrade date',
    contactService: 'Contact customer service',
    changeCard: 'Update billing credit card',
    SelectCard: 'Please select the billing credit card',
    cancel: 'Cancel subscription',
    cancelTip1: 'If you cancel the subscription, the plan will end on {date}, and it will no longer renew automatically. After this date, all members will lose access to the system. Are you sure you wish to proceed with the cancellation?',
    cancelTip2: 'Canceling the subscription will disable automatic renewal. As a result, all members will lose access to the system. Are you sure you wish to proceed with the cancellation?',
    revokeCancellation: 'Cancel subscription cancellation',
    revokeTip: 'Do you want to cancel the subscription cancellation? If you undo it, you can cancel again later.',
    noPlan: 'There are no available plans at this time.',
    newPlan: 'Updated plan',
    learn: 'Plan details',
    learnMore: 'View plan details',
    confirmOrder: 'Review the order',
    orderInfo: 'Order information',
    planStart: 'Plan start date',
    planStartInstant: 'Once the payment has been completed',
    item: 'Item',
    itemName: 'Item name',
    modelName: 'Model name',
    diagramType: 'Drawing type',
    category: 'Category',
    totalItem: 'Quantity',
    unitPriceYen: 'Unit price',
    totalSumYen: 'Total price',
    unitPrice: 'Unit price',
    totalSum: 'Total price',
    unusedSum: 'Unused package balance',
    quickSum: 'Total',
    tax: 'Tax (10%)',
    payableSum: 'Payment amount',
    payableSumUnit: 'Payment amount (JPY)',
    submit: 'Submit',
    confirmSubmit: 'Confirm and submit the order',
    createUser: 'Creator',
    createTime: 'Creation time',
    paidTime: 'Payment time',
    giveTime: 'Delivery time',
    paidStatus: 'Payment status',
    cadStatus: 'CAD creation status',
    orderSum: 'Order amount',
    status: 'Payment status',
    leftTime: 'Remaining payment period',
    switchTipYear: 'The payment will switch to an annual plan starting on {date}.',
    switchTipMonth: 'The payment will switch to a monthly plan starting on {date}.',
    autoFail: 'The automatic payment failed.',
    cardFailTip: 'The credit card payment has failed. A retry will be attempted tomorrow. Please update your payment information at your earliest convenience.',
    toSwitch: 'Proceed to update',
    details: 'Order details',
    type: 'Order type',
    sumTip: 'Total amount = Plan unit price × Additional users × Remaining days / {n} days',
    unusedTip: 'Unused amount (original plan) = Old plan unit price × Original number of users × Unused days / {n} days',
    priceTip: 'Time-based rate conversion: Unit price = Original plan unit price × Remaining usage days / {n} days',
    oldPlan: 'Original plan',
    unusedTime: 'Remaining usage days',
    actionDetail: 'Details',
    checkDetail: 'Review the details',
    actionPay: 'Proceed to payment',
    actionCancel: 'Cancel the order',
    cancelConfirm: 'Are you certain you wish to cancel the order?',
    actionInvoice: 'Download transaction documents',
    actionDiagram: 'Download drawing',
    submitOrder: 'Submit the order',
    payOrder: 'Pay for the order',
    completeOrder: 'Order completed',
    applican: 'Applicant',
    appliTime: 'Application date and time',
    checkCancel: 'Review the cancellation reason',
    cancelTime: 'Cancellation time',
    cancelReason: 'Cancellation reason',
    useTip: 'Available immediately after successful payment',
    unpaidTip: 'You have an unpaid plan order. Please complete the payment or contact your service provider.',
    leftDay: 'days',
    leftHr: 'hours',
    leftMin: 'minutes',
    leftSec: 'seconds',
    expireTip: 'The order will be automatically canceled if payment is not received by the deadline.',
    purchaseSuccess: 'Thank you! Your purchase was successful.',
    existPlantip: 'You have already purchased the {plan} plan and cannot purchase a new plan. Please cancel your current order and purchase a new plan.',
    unactivePlantip: 'You have already purchased the {plan} plan. Your subscription starts on {date}.',
    currentSeat: 'Current Number of IDs',
    seatExpandExceed: 'Your current plan allows up to {max-seat} seats. You have {exist-seat} seats and can add {left-seat} more. Please adjust the quantity and try again.',
    checkCurrentPlan: 'View current plan',
    noPlanError: 'You currently do not have an active subscription plan. Expansion of ID count is not available. Please contact your Account Manager to cancel your pending order and repurchase a plan.',
    planType: 'Order plan',
    itemList: 'Order List',
    system: 'System',
    selectNumber: 'Select Quantity',
    numberOfPlan: 'Plan Quantity',
    numberOfID: 'Additional IDs',
    numberTip1: 'Total:{detail0}IDs',
    numberTip2: 'Selected Plan includes {detail0}IDs',
    card: {
      '3DsTip': '3D Secure authentication is required for credit card automatic payment. The system has sent an authentication email, so please check your email and complete the authentication.'
    },
    complete: 'Complete'
  },
  cad: {
    statusProcessing: 'CAD drawing in progress',
    statusComplete: 'CAD drawing completed',
    submit: 'Submit the application',
    completeTime: 'Approximately 2 to 4 days',
    create: 'CAD drawing',
    delivery: 'Submit drawings',
    model: 'Model',
    innerWall: 'Interior wall thickness',
    outerWall: 'Exterior wall thickness',
    deliveryFormat: 'Delivery format',
    usage: 'Building Categories',
    type: 'Type of Drawings',
    attachment: 'Existing Drawings',
    application: 'Request for CAD drawing',
    usageResidential: 'Residential',
    usageOffice: 'Office',
    usageShop: 'Shop and Institution',
    usageOthers: 'Other',
    fileCad: 'CAD File',
    filePdf: 'PDF File',
    diagramFloorplan: 'Floor Plan',
    diagramCeiling: 'Ceiling Plan',
    diagramElevation: 'Elevation',
    tipProcessing: 'The drawings are currently being created. We kindly ask for your patience.'
  },
  pay: {
    payment: 'Payment method',
    detailCard: 'Payment information - Credit card',
    detailInvoice: 'Payment information - Invoice',
    orderPay: 'Order payment',
    selectMethod: 'Select payment method',
    creditcard: 'Credit card',
    invoice: 'Invoice',
    invoiceSendTip: 'The invoice will be sent to {mail}. Please make the payment to the following account:',
    invoiceResendTip: 'The invoice has been sent to {mail}. Please make the payment to the following account:',
    bank: 'Financial Institution',
    banCode: 'Financial Institution Code',
    bankName: 'Branch Name',
    bankNumber: 'Branch Number',
    accountType: 'Account Type',
    accountOwner: 'Account Holder',
    accountNumber: 'Account Number',
    sendInvoice: 'Send Invoice',
    noInvoice: 'The invoice has not been received?',
    resendInvoice: 'Resend Invoice',
    InvoiceSent: 'Invoice sent successfully',
    toPay: 'Proceed to payment',
    agreement: 'Agree to the Purchase Agreement',
    payLoading: 'Please wait while we process your payment...',
    payJump: 'Payment is being processed. Redirecting to order page...',
    unlimited: 'Unlimited',
    alert: 'This order requires payment by bank transfer. Please check your inbox.If you haven\'t received the email regarding the transfer, or if you have any other questions, please contact the service provider.'
  },
  team: {
    member: 'Member management',
    status: 'Status',
    statusActive: 'In use',
    statusUnactive: 'Not activated',
    addMember: 'Add member',
    deleteMember: 'Remove member',
    deleteMemberTip: 'If you remove the member, they will no longer have access to your company. However, any models uploaded to the cloud will remain retained. Are you sure you wish to proceed with this action?',
    addMultiMember: 'Batch Add Members',
    memberFormDownload: 'Click to download the "User Batch Import Template"',
    addMultiMemberTip: '1. Download the "User Batch Import Template."\\n\n2. Open the template, enter or paste the corresponding field information using plain text or numbers.\\n\n3. Click the "Upload File" button, select the completed file, and then click the "Confirm Import" button at the bottom right corner.\\n\nNote: You can import a maximum of 100 records at once. If the file uploaded exceeds 100 records, none of the data will be imported.',
    errorNoFile: 'Please upload the file',
    usedSeat: 'Active ID',
    model: 'Total number of models',
    cloudModel: 'Number of cloud models',
    name: 'Name',
    inputLastname: 'Please enter last name',
    inputname: 'Please enter first name',
    mail: 'Email',
    mailAddress: 'Email address',
    inputEmail: 'Enter the email address',
    emptyEmail: 'Please provide your email address!',
    errorEmail: 'The email address format you entered is incorrect. Please review it and try again.',
    activeAccount: 'Activate Account',
    activeAccountTip: 'An activation email will be sent to this member. Would you like to confirm the account activation?',
    lastLogin: 'Last login time',
    editMember: 'Edit member',
    deleteMultiMember: 'Batch Remove Members',
    deleteMultiMemberTip: 'If you remove selected members, they will no longer have access to your company. However, any models uploaded to the cloud will remain retained. Are you sure you wish to proceed with this action?',
    contactPhone: 'Contact Support: ',
    contactEmail: 'Email Support:',
    cannotRemoveAdminOrSelf: 'Cannot remove super administrator or yourself',
    removeSuccess: 'Member(s) removed successfully',
    statusDisabled: 'Disable',
    role: {
      owner: 'Owner',
      superManger: 'Super administrator',
      manager: 'Administrator',
      ScanatUser: 'Scanat User',
      viewUser: 'Viewer',
      name: 'Role',
      updateSuccess: 'Role Updated Successfully',
      noRole: 'No Role'
    },
    operate: {
      enable: 'Enable',
      disable: 'Disable'
    },
    prompt: {
      buyScanatWeb: 'Scanat Web Service Purchased'
    },
    add: {
      chooseRole: 'Select Role',
      manageSeat: 'ID Consumption',
      seatTip1: 'No ID consumption when turned off.',
      seatTip2: 'One ID will be consumed when turned on.'
    },
    enable: {
      noRight: 'You do not have permission to enable this account',
      tip: 'Once enabled, this account can be used normally. Are you sure you want to enable it?',
      success: 'Enabled successfully',
      noPlan: 'The company is not subscribed. Account cannot be enabled.'
    },
    disable: {
      noRight: 'You do not have permission to disable this account',
      tip: 'Once disabled, this account will be unusable. The account data will not be deleted, and it can be re-enabled later. Do you confirm disabling the account?',
      success: 'Disabled successfully'
    },
    statusDisabledTxt: 'Disabled',
    seatTip: 'Scanat service becomes available after an ID is consumed.',
    delete: {
      noRight: 'You do not have permission to delete this account.'
    },
    seat: {
      total: 'Contract ID',
      manageSeat: 'ID Consumption',
      onSuccess: 'ID consumed successfully',
      noSeat: 'No IDs available. Operation failed.',
      offSuccess: 'ID released successfully'
    }
  },
  survey: {
    title: 'Plan Unsubscription Customer Survey',
    desc: 'Thank you for using Scanat.\n If you wish to cancel your subscription, please fill out the required fields in the form below and submit it.\n After receiving the form, our representative will contact you by phone or email on our business days.',
    questionReason: 'Reason for your unsubscription (Multiple Choice)',
    reason1: 'Low measurement accuracy',
    reason2: 'Difficult scanning or operation methods',
    reason3: 'Low usage frequency',
    reason4: 'Insufficient functionality',
    reason5: 'High cost',
    reason6: 'Inadequate support system',
    questionApp: 'Which other scanning systems have you used? (Select all that apply)',
    app1: '3D Scanner',
    app2: 'Canvas',
    app3: 'Metascan',
    app4: 'Modelar',
    app5: 'Matterport',
    app6: 'OpalUI',
    app7: 'Polycam',
    app9: 'Scaniverse',
    app10: 'Sitescope',
    questionRecommend: '3. How likely would you be to suggest Scanat to friends needing 3D scanning services?',
    descRecommend: '*On a scale of 0-10, where 0 means "extremely unlikely" and 10 means "extremely likely"',
    questionOther: 'Feedback or suggestions',
    descOther: 'If you have any requests regarding Scanat, or suggestions for additional features or improvements, please feel free to let us know. (Free comment field)',
    submit: 'Submit',
    error: 'Please answer this question.',
    complete: 'Submitted successfully',
    thanks: 'Thank you for your valuable time. nat will process your application as soon as possible!',
    profileTitle: 'Your Profile (All items are required)',
    questionReasonDesc: 'Please select all applicable items.',
    reason7: 'Due to departmental or personnel changes',
    reason8: 'Switched to another company\'s product',
    contactTip: 'If you have any questions, please contact us below.',
    contact: '【Contact】\n- Tel：050-1780-7133\n- E-mail：cs{\'@\'}natincs.com',
    profileOwnerHint: 'Example:Yamada Taro',
    profilePhoneHint: 'Example:05017807133',
    profileMailHint: 'Example:scanat{\'@\'}natincs.com',
    profileOwnerEmpty: 'Please enter the main person in charge',
    profilePhoneEmpty: 'Please enter the phone number',
    profileMailEmpty: 'Please enter the email address',
    profilePhoneError: 'Please enter a valid phone number',
    profileMailError: 'Please enter a valid email address',
    reasonOtherEmpty: 'Content cannot be empty. Please enter details.',
    reasonEmpty: 'Please select the reason for unsubscription',
    waiting: 'Waiting for processing...',
    submited: 'Your unsubscription request has been submitted. Please wait patiently. \n- Contact phone: 050-1780-7133\n- Contact Email: cs{\'@\'}natincs.com',
    submitedOther: '{id} has submitted an unsubscription request. Please wait patiently.\n- Contact Phone: 050-1780-7133\n- Contact Email: cs{\'@\'}natincs.com'
  },
  log: {
    title: 'Operation log',
    searchHint: 'Input the account to search',
    remark: '※Operation logs from the past year are available for viewing.',
    account: 'Account',
    time: 'Operation time',
    system: 'Associated system',
    page: 'Operation Page',
    action: 'Action',
    detail: 'Details',
    ip: 'IP address',
    device: 'Device',
    overtimeError: 'Logs older than one year are not available for viewing. Please select a different time period.',
    noUserError: 'Account not found.'
  },
  share: {
    people_amount: '{n}',
    accountShare: 'Share via Account',
    linkShare: 'Share via Link',
    searchHint: 'Enter Contact Account to Search',
    searchEmpty: 'No matching contacts found. \nPlease try a different keyword.',
    limits: 'Permissions',
    read: 'View only',
    edit: 'Editable',
    manage: 'Manageable',
    resetLink: 'Reset Link',
    overwritePw: 'Overwrite existing password',
    unSaveTip: 'Please save or cancel your password first',
    title: {
      privateLink: 'Private Link',
      encryptedLink: 'Password-Protected link',
      publicLink: 'Public link',
      changeLinkPassword: 'Change Link Password'
    },
    desc: {
      privateLink: '・Accessible only to team members',
      encryptedLink: '・Anyone with the password can access',
      publicLink: '・Anyone can access'
    },
    hint: {
      changeLinkPassword: 'Please enter 4-20 numbers or letters.'
    },
    toast: {
      changeModeSuccess: 'Permissions set successfully.',
      noPermission: 'Modifications are restricted to the model owner and administrators.',
      save: 'Please save or cancel your password first.',
      noPermissionNew: 'You need edit or manage permissions for the model.'
    },
    alert: {
      title: {
        changeToPublic: 'Note'
      },
      info: {
        changeToPublic: 'Once enabled, anyone on the internet with the link can access the model.'
      }
    },
    copy: 'Model link copied. Share it with others to provide access to the model.',
    link1: '{detail0}',
    link2: 'Scanat model link:{detail0}\npassword: {detail1}',
    privateLink: {
      linkFail: 'The link is no longer valid.',
      tip: 'The current login account is "{id}". You can contact "{admin_id}" to obtain a new link',
      contactManage: 'Access denied. Please contact your administrator.',
      limitPermission: 'The currently logged-in account "{id}" is not authorized to access this model.'
    },
    encryptedLink: {
      needPassword: 'Access to this model requires a password.',
      errorPassword: 'Please enter the correct password.',
      go: 'Go',
      placeholder: 'Please enter the password.'
    },
    copyLink: 'Copy Link',
    modelNotFound: 'The model of "{modelName}" has been deleted.',
    link: {
      noModel: 'Model not found.',
      noModelTip: 'Please verify the link.'
    }
  },
  import: {
    model: 'Import model',
    fail: 'Import failed!',
    reimport: 'Reimport model',
    importGuide: 'Select a 3D file or drop it here to import.',
    importFormat: 'Supported formats: OBJ / GLTF / GLB / DRC / STL / PLY / DAE / FBX / SKP / USDZ / DXF / ZIP\nIf textures are included, please compress them into a ZIP file before importing.',
    releaseMouse: 'Drop file to import',
    localFile: 'Select the file',
    reSelect: 'Reselect the file',
    wrongFormat: 'The selected file format is not supported. Please choose a different file.',
    fileSizeLimit: 'File size exceeds the limit.'
  },
  period: {
    lastWeek: 'Last 7 days',
    lastMonth: 'Last 30 days',
    lastYear: 'Last 1 year'
  },
  menu: {
    company: 'Company infomation',
    log: 'Operation log',
    order: 'Order History',
    team: 'ID Management'
  },
  title: {
    team: 'ID Management',
    company: 'Company infomation',
    order: 'Order History',
    log: 'Operation log',
    buy: 'Purchase',
    pay: 'Order Payment',
    paySuccess: 'Payment Successful',
    orderInfo: 'Order Details',
    land: 'Service Selection',
    link: {
      useless: 'Expired Link',
      notExist: 'Link Not Found'
    }
  },
  SUCCESS: 'Success',
  VALIDATE_FAILED: 'Parameter validation failed.',
  UNAUTHORIZED: 'You have not registered yet or your login session has expired.',
  INVALID_PASSWORD: 'The E-mail or password is not correct.',
  UNAVAILABLE: 'Your account must be activated by our sales team after completing the corporate contract process. Please contact to  for inquiries.',
  FORBIDDEN: 'You do not have the required permissions.',
  POSTCODE_NOT_EXIST: 'Postal code does not exist.',
  NOT_REGISTERED: 'This email is not registered.',
  VERIFICATION_CODE_ERROR: 'The verification code is incorrect.',
  VERIFICATION_CODE_EXPIRE: 'The verification code has expired.',
  USER_NOT_EXIST: 'User does not exist.',
  CRM_ACCOUNT_NOT_EXIST: 'Account does not exist. Please contact customer service for assistance.',
  USER_EXIST: 'User already exists.',
  CONFIRM_PASSWORD: 'Passwords do not match.',
  FILE_UPLOAD_KEY_GET_FAIL: 'Failed to get key.',
  MODEL_NOT_BELONG: 'This model does not belong to you.',
  FAILED: 'Failed',
  REQUEST_FREQUENTLY: 'You are performing actions too frequently. Please try again later.',
  FILE_SHARE_ERROR_DEL: 'Failed to send the file because it has been deleted.',
  FILE_SHARE_ERROR_UNAUTHORIZED: 'You are not authorized to perform this action.',
  FILE_SHARE_ERROR_EMAIL_NOT_EXISTS: 'User ID does not exist.',
  FILE_SHARE_ERROR_UNKNOWN: 'Unknown error.',
  FILE_SHARE_ERROR_REPEAT_SHARING: 'Model has already been sent to this user.',
  FILE_SHARE_ERROR_SELF: 'You cannot send a copy to yourself.',
  FILE_SHARE_UPDATE_FAIL: 'Update failed. The shared file cannot be found.',
  FILE_DOWNLOAD_ERROR_DEL: 'The file has already been deleted and cannot be downloaded.',
  FILE_SHARE_DEL_FAIL: 'Inbox is emtpy and cannot be deleted.',
  FILE_SHARE_DEL_FAIL_NO_AUTHORITY: 'Cannot delete the copy of the model.',
  CREDIT_CARD_PAY_ERROR: 'Failed to restore subscription',
  CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY: 'Card payment failed. Reason: no data found.',
  PERMITS_CONVERT_FAIL: 'Failed to restore subscription',
  PERMITS_CONVERT_FAIL_USER_NULL: 'Failed to restore subscription',
  APP_TRANSLATION_INVALID: 'User does not exist',
  APP_TRANSLATION_HISTORY_GET_FAIL: 'Failed to retrieve subscription data',
  APP_TRANSLATION_STATUS_GET_FAIL: 'Failed to retrieve subscription data',
  FILE_UPLOAD_FILE_PATH_EMP_ERROR: 'Update failed: Please enter file path.',
  FILE_UPLOAD_FILE_DB_FAIL_ERROR: 'Update failed: model record error.',
  APP_TOKEN_GET_FAIL: 'Failed to retrieve parameters.',
  APP_IP_ADDRESS_NOT_ALLOW: 'The IP address cannot be accessed.',
  CONTACT_ALREADY_EXIST: 'The contact already exists. Please do not add it again.',
  ACCOUNT_PLAN_NOT_EXIST: 'Plan not yet purchased.',
  ACCOUNT_PLAN_TYPE_ERROR: 'Please verify the plan type.',
  ACCOUNT_PLAN_DOWNGRADE: 'It is not allowed to downgrade a plan.',
  ACCOUNT_PLAN_PREPAY_MONTH_ERROR: 'Please verify the plan information.',
  ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER: 'Plan changes are not allowed until the end of the prepayment period.',
  CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST: 'User\'s Fincode ID not found.',
  FINCODE_PLAN_ID_NOT_EXIST: 'Fincode ID does not exist.',
  CUSTOMER_NAME_DUPLICATE: 'The username already exists. Please verify.',
  CUSTOMER_NAME_BLANK_NOT_ALLOW: 'Please input username.',
  ACCOUNT_NOT_EXIST: 'User ID does not exist.',
  CUSTOMER_NOT_EXIST: 'User does not exist.',
  FINCODE_CARD_ID_BLANK_NOT_ALLOW: 'Please input Fincode ID.',
  CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN: 'The user is not associated with any plans.',
  CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT: 'Payment request has been sent. Please wait while the transaction is being processed and confirmed.',
  ACCOUNT_IN_USE_HAS_REACHED_MAX: 'The number of available IDs has reached the limit.',
  ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX: 'The total number of IDs newly added and in use, has reached the limit of the plan.',
  ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES: 'This email is already taken.',
  ACCOUNT_EMAIL_ALREADY_EXISTS: 'Email already exists.',
  ACCOUNT_LIST_CANNOT_BE_EMPTY: 'Account list cannot be empty.',
  FREEE_TOKEN_GET_ERROR: 'An authentication error occured with Freee.',
  FREEE_API_REQUEST_ERROR: 'An error occurred while sending a request to Freee\'s API.',
  FREEE_INVOICE_LIST_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve the invoice list.',
  FREEE_INVOICE_DETAIL_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve invoice details.',
  FREEE_ADD_INVOICE_ERROR: 'An error occurred while sending a request to Freee\'s API to add an invoice.',
  FREEE_ADD_PARTNER_ERROR: 'An error occurred while sending a request to Freee\'s API to add a customer.',
  FREEE_UPDATE_PARTNER_ERROR: 'An error occurred while sending a request to Freee\'s API to update a customer.',
  FREEE_PARTNER_DETAIL_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve customer information.',
  FREEE_PARTNER_LIST_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve the customer list.',
  ACCOUNT_PLAN_ORDER_NOT_EXISTS: 'Customer\'s contracted plan information does not exist.',
  CUSTOMER_ALREADY_ADDED: 'Customer information already exists.',
  ORDER_NOT_EXIST: 'Order does not exist.',
  ORDER_STATUS_ERROR: 'Orders status error.',
  ORDER_PAYMENT_METHOD_NOT_ALLOW: 'Payment method for this order is not supported.',
  FINCODE_CUSTOMER_CARD_NOT_FOUND: 'Fincode card does not exist.',
  FREEE_PARTNER_NOT_FOUND: 'Freee customer information not found.',
  CUSTOMER_ALREADY_BOUND_PLAN: 'Payment request has been sent. Please do not send it again.',
  MY_USER_PHONE_NUMBER_ALREADY_EXISTS: 'User phone number already exists.',
  MY_USER_EMAIL_ALREADY_EXISTS: 'User email already exists.',
  ROLE_NAME_DUPLICATE: 'Role name already exists.',
  THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED: 'The role is currently assigned to users and cannot be disabled. ',
  THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT: 'The role is currently assigned to users and cannot be edited. ',
  THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED: 'The role is currently assigned to users and cannot be deleted. ',
  ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS: 'Adding sub-departments under the headquarters is not allowed.',
  AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION: 'Please enter postal code and address of agency.',
  MOST_FIVE_DEPT_LEVELS: 'Departments are limited to a maximum of 5 levels. Adding more levels is not allowed',
  DEPT_NAME_ALREADY_EXISTS: 'Department name already exists.',
  THE_DEPT_HAS_SUB_DEPT: 'This department has sub-departments and cannot be deleted.',
  THERE_ARE_USERS_IN_THIS_DEPT: 'This department has associated users and cannot be deleted.',
  THERE_ARE_ROLES_BOUND_TO_THIS_DEPT: 'This department has associated roles and cannot be deleted.',
  THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT: 'This department owns account plans and cannot be deleted.',
  CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD: 'The customer name already exists and cannot be added.',
  THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS: 'The department associated to the customer does not exist.',
  CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE: 'The customer name already exists and cannot be modified.',
  THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT: 'Account cannot be activated because the customer has no linked account plan.',
  THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT: 'Account cannot be activated because the customer\'s plan package has not taken effect yet.',
  THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED: 'The number of activated accounts has reached the plan ID limit, no more accounts can be activated.',
  THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: 'The customer has no linked account plan, activated accounts cannot be transferred to this customer.',
  THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: 'The customer\'s account plan has not yet taken effect, activated accounts cannot be transferred to this customer.',
  THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: 'The customer has no linked account plan, cannot add an activated account.',
  THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: 'The customer\'s account plan has not yet taken effect, cannot add an activated account.',
  THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT: 'The number of activated accounts has reached the plan ID limit, cannot add an activated account.',
  THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST: 'Agent users do not have permission to view the CAD order list.',
  CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES: 'The order is complete. No files can be uploaded anymore.',
  CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE: 'This role belongs to the headquarters and cannot be linked to menus that are only accessible by agents.',
  CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE: 'This role belongs to agents and cannot be linked to menus that are only accessible by the headquarters.',
  THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED: 'It it not allowed to delete this plan because it is being used by a customer.',
  THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE: 'The owning department of the device cannot be an agent.',
  CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED: 'Cannot delete the device because it is currently in use by a customer.',
  THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED: 'The current device is the standard equipment for an active account plan and cannot be deleted.',
  ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: 'Failed to add new customer. The customer name already exists in the database.',
  ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS: 'Failed to add. The third-party customer name already exists.',
  UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: 'Failed to update. The customer name already exists in the database.',
  THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT: 'The department cannot be changed because the customer has an active plan order.',
  THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT: 'The department cannot be changed because the customer has an active device order.',
  CUSTOMER_INFO_NOT_ADDED: 'Company infomation has not been filled in. You will be able to purchase a plan after fiiling in the company information.',
  FREEE_PARTNER_NOT_EXIST: 'Customer information does not exist in Freee, please check if the accound ID has been entered correctly.',
  INVITATION_NOT_EXIST: 'Invitation does not exist.',
  INVITATION_STATUS_ERROR: 'Invitation status error.',
  INVITATION_STATUS_INVALID: 'The invitation has been revoked. Please contact the inviting administrator to resend the invitation.',
  INVITATION_STATUS_EXPIRED: 'The invitation has expired. Please contact the inviting administrator to resend the invitation.',
  INVITATION_CHECK_CODE_WRONG: 'The verification code is incorrect.',
  CUSTOMER_ACCOUNT_PLAN_IN_EFFECT: 'This account is already subscribed. Please verify if you are sending the invitation to the correct account.',
  CUSTOMER_NOT_ALLOW_CHANGE: 'Change of customer is not allowed.',
  USER_STATUS_UNAVAILABLE: 'A paid subscription is required to use Scanat. Please purchase a plan on Scanat website before logging in.',
  USER_STATUS_AVAILABLE: 'Logged in successfully.',
  USER_STATUS_ACCOUNT_EXPIRED: 'Account expired. Please renew your plan.',
  USER_STATUS_LOGOUT: 'The specified account does not exist. Please verify the account information and try again',
  USER_STATUS_ACTIVE: 'Logged in successfully.',
  USER_STATUS_TO_BE_EFFECTIVE: 'Your account has not been activated yet. Please contact your company administrator %@ for assistance.',
  USER_STATUS_DEACTIVATE: 'Your account has been disabled by the administrator. Please contact your company administrator %@ for assistance.',
  USER_STATUS_PRE_DEACTIVATE: 'Logged in successfully.',
  USER_STATUS_PRE_ABNORMALITY: 'Login failed. There is an issue with your account.',
  AGENT_NOT_EXIST: 'Agent does not exist.',
  AGENT_NAME_DUPLICATE: 'Agent name already exists.',
  REQUEST_BOOK_NOT_EXIST: 'Invoice does not exist.',
  FILE_CREATE_FAIL: 'Failed to create file.',
  SALES_DATE_EMPTY: 'Please enter the transaction date.',
  EXTEND_PLAN_CONFIG_ERROR: 'Extra ID plan is not set. Please contact your administrator for assistance.',
  CAN_NOT_FIND_WEB_MODEL_KEY: 'Model does not exist.',
  CAN_NOT_FIND_WEB_MODEL_FOLDER: 'Folder does not exist.',
  FOLDER_CANT_MOVE_INTO_SUB_FOLDER: 'Failed to move the folder. A folder cannot be moved into a subfolder.',
  FOLDER_CONTAIN_SUB_FOLDER: 'Failed to move the folder. The selected folder contains subfolders and cannot be moved to another folder.',
  WEB_MODEL_ALREADY_IN_FOLDER: 'Failed to move. The item already exists in the folder.',
  FOLDER_NAME_SAME: 'A folder with the same name already exists. Please rename it before saving.',
  EMAIL_CODE_REQUIRED: 'We have added authentication to enhance security. To use this feature, please update your app to the latest version (v1.8.2 or above).',
  FILE_SHARE_FAIL: 'Failed to send: {}',
  NOT_HAS_WEB_PERMISSION: 'Access denied because you have not purchased this service.',
  MODEL_OUTLINE_NOT_EXIST: 'Line Diagram does not exist.',
  WEB_MODEL_NO_AUTH: 'Insufficient permissions.',
  SEAT_NUM_TOO_SMALL: 'The number of IDs is below the minimum limit.',
  SEAT_NUM_TOO_BIG: 'The number of IDs exceeds the maximum limit.',
  SEAT_NUM_LESS_THAN_USED: 'Insufficient number of IDs.',
  CUSTOMER_PLAN_NOT_CANCELED: 'The customer has no cancelled plans.',
  CUSTOMER_PLAN_EXIST: 'The customer has already purchased a plan.',
  CUSTOMER_PLAN_ALREADY_CANCELED: 'The customer\'s plan has been cancelled.',
  CUSTOMER_PLAN_NOT_A: 'The customer is not subscribed to Plan A.',
  CUSTOMER_PLAN_PERIOD_ERROR: 'This subscription method is not supported.',
  START_TIME_ILLEGAL: 'Incorrect start time.',
  STRIPE_ONE_TIME_PRICE_NOT_FOUND: 'The plan does not exist.',
  CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM: 'The plan does not exist.',
  ORDER_NOT_BELONG: 'This order does not belong to your company.',
  WEB_PERMISSION_NOT_ALLOW_INACTIVE: 'Insufficient permissions.',
  CUSTOMER_HAS_ACCOUNT_IN_USE: 'Your company currently has accounts in use.',
  CAD_PLAN_GOODS_NOT_EXIST: 'Unable to find this CAD product.',
  CAD_ORDER_NOT_EXIST: 'This CAD order does not exist.',
  CAD_ORDER_STATUS_ERROR: 'This CAD order status is incorrect.',
  CAD_ORDER_FILE_TOO_MANY: 'This CAD order file size exceeds the maximum limit.',
  ACCOUNT_PLAN_PERIOD_NOT_ALLOW: 'This subscription method is not supported.',
  CUSTOMER_PLAN_END_TIME_BEFORE_NOW: 'The plan has not expired yet.',
  EXPAND_SEAT_NOT_ZERO: 'The number of IDs must be at least 1.',
  EXPAND_A_NOT_ALLOW: 'Adding IDs is not supported on Plan A.',
  ACCOUNT_PLAN_GOODS_NOT_EXIST: 'The plan does not exist.',
  CAD_PLAN_GOODS_IS_USED: 'The CAD plan is in use.',
  DOMAIN_ALREADY_EXIST: 'This domain is already registered.',
  LOCATION_WITH_SNAPSHOT: 'This capture point is already associated with a highlight.',
  LOCATION_NOT_FOUNT: 'The capture point does not exist.',
  FLOOR_NOT_EXIST: 'The floor does not exist.',
  AUTO_ALIGN_FAIL: 'Automatic orientation correction failed.',
  CAN_NOT_CHANGE_MEMBER_ROLE: 'Unable to change member roles.',
  CAN_NOT_USE_SEAT: 'You do not have permission to toggle ID consumption.',
  APPLICATION_NOT_EXIST: 'The unsubscribe request does not exist.',
  PROCESSING_RESULT_NOT_EXIST: 'The result of the unsubscribe request does not exist.',
  PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST: 'The reason for the unsubscribe request does not exist.',
  PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL: 'The Other reason is required for unsubscribe.',
  PLAN_CANCEL_APPLICATION_EMAIL_ERROR: 'The email address entered for the unsubscribe request does not match the current account.',
  PLAN_CANCEL_APPLICATION_EXIST: 'An unsubscribe request already exists.',
  ACCOUNT_CAN_NOT_USE: 'Your account is unavailable.',
  ACCOUNT_NO_SEAT: 'The "ID Consumption" setting is turned off for this account, so app access is unavailable. ',
  CAN_NOT_EDIT_MEMBER: 'Unable to edit members. ',
  MODEL_IS_NOT_EXIST: 'The model does not exist.',
  SHARE_LINK_NOT_EXIST: 'The shared link does not exist.',
  NOT_CUSTOMER_MEMBER: 'Not a member of this company.',
  SHARE_LINK_PASSWORD_ERROR: 'The password you entered for the shared link is incorrect.',
  STRIPE_PAYMENT_METHOD_NOT_ALLOW: 'Stripe payments are not supported.',
  NOT_ADMIN_FORBIDDEN: 'Not an administrator.',
  NOT_ACTIVE_FORBIDDEN: 'Account is not activated.',
  toast: {
    noMovePermission: 'You do not have permission to move to the destination folder. Please select another destination.',
    exist: 'Already exists in the destination.',
    cannotMove: 'Cannot move to this folder or its subfolders.',
    depth: {
      exceed: 'Folder hierarchy limit reached. Please select another folder.'
    }
  },
  map: {
    gpsEnabledModelCount: '{n} models with GPS positioning',
    emptyFolderNoGpsModel: 'No models with GPS positioning in this folder.',
    searchNoResult: 'No results found. Please try changing the keyword, checking the input, or adjusting the filters.'
  },
  maps: {
    hover: {
      showAllModels: 'Show all models',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out'
    }
  },
  collaborator: {
    set: 'Manage collaborators',
    add: 'Add collaborators',
    search: {
      email: 'Enter the member\'s email'
    },
    online: 'Online',
    owner: 'Owner (Company)',
    title: 'collaborator'
  },
  fileModal: {
    cannotOperate: 'Actions are disabled. The file has been deleted.'
  },
  collaboratorlist: {
    set: 'Collaborator List'
  },
  member: {
    searchHint: 'Enter an account to search',
    searchEmpty: 'No results found. Please search with another keyword.',
    addMember: 'Add collaborators',
    owner: 'Owner',
    admin: 'Super Administrator',
    outsider: 'External Member'
  },
  ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER: 'This email is already registered. Please use a different email to create a company.',
  COOPERATOR_PERMISSION_DENIED: 'No collaboration permissions.',
  TEAM_SPACE_FOLDER_CREATE_NO_ADMIN: 'Only members with administrative privileges can create folders in the team space.',
  NOT_A_FOLDER: 'Not a folder.',
  FOLDER_SPACE_MISMATCH: 'No folder space found.',
  FOLDER_DEPTH_EXCEEDED: 'Folder hierarchy limit reached. Please select another folder.',
  SPACE_FOLDER_CONTAIN_SUB_FOLDER: 'Cannot move to this folder or its subfolders.',
  SPACE_FILE_ALREADY_IN_FOLDER: 'Already exists in the destination.',
  CAN_NOT_FIND_SPACE_FILE: 'Unable to access.The file has been deleted.',
  SPACE_FILE_PATH_NULL: 'File path is empty.',
  COOPERATOR_ALREADY_EXISTS: 'Already in the collaborator list. Addition failed.',
  INVITE_KEY_NOT_EXIST: 'The invitation link does not exist.',
  INVITE_EMAIL_ERROR: 'The invitation email address is invalid.',
  INVITE_STATUS_ERROR: 'Invitation status error.',
  INVITE_STATUS_EXPIRED: 'The invitation has expired.',
  INVITE_CUSTOMER_PLAN_NOT_EXIST: 'Unable to access the page because the inviter has not purchased a subscription.'
}
